/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupRecordingResponseExistingArtistsInner } from './LookupRecordingResponseExistingArtistsInner';
import {
    LookupRecordingResponseExistingArtistsInnerFromJSON,
    LookupRecordingResponseExistingArtistsInnerFromJSONTyped,
    LookupRecordingResponseExistingArtistsInnerToJSON,
} from './LookupRecordingResponseExistingArtistsInner';
import type { LookupRecordingResponseExistingRecording } from './LookupRecordingResponseExistingRecording';
import {
    LookupRecordingResponseExistingRecordingFromJSON,
    LookupRecordingResponseExistingRecordingFromJSONTyped,
    LookupRecordingResponseExistingRecordingToJSON,
} from './LookupRecordingResponseExistingRecording';
import type { LookupRecordingResponseExistingRelease } from './LookupRecordingResponseExistingRelease';
import {
    LookupRecordingResponseExistingReleaseFromJSON,
    LookupRecordingResponseExistingReleaseFromJSONTyped,
    LookupRecordingResponseExistingReleaseToJSON,
} from './LookupRecordingResponseExistingRelease';

/**
 * 
 * @export
 * @interface LookupRecordingResponseExisting
 */
export interface LookupRecordingResponseExisting {
    /**
     * 
     * @type {LookupRecordingResponseExistingRecording}
     * @memberof LookupRecordingResponseExisting
     */
    recording: LookupRecordingResponseExistingRecording;
    /**
     * 
     * @type {Array<LookupRecordingResponseExistingArtistsInner>}
     * @memberof LookupRecordingResponseExisting
     */
    artists: Array<LookupRecordingResponseExistingArtistsInner>;
    /**
     * 
     * @type {LookupRecordingResponseExistingRelease}
     * @memberof LookupRecordingResponseExisting
     */
    release?: LookupRecordingResponseExistingRelease | null;
}

/**
 * Check if a given object implements the LookupRecordingResponseExisting interface.
 */
export function instanceOfLookupRecordingResponseExisting(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recording" in value;
    isInstance = isInstance && "artists" in value;

    return isInstance;
}

export function LookupRecordingResponseExistingFromJSON(json: any): LookupRecordingResponseExisting {
    return LookupRecordingResponseExistingFromJSONTyped(json, false);
}

export function LookupRecordingResponseExistingFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupRecordingResponseExisting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recording': LookupRecordingResponseExistingRecordingFromJSON(json['recording']),
        'artists': ((json['artists'] as Array<any>).map(LookupRecordingResponseExistingArtistsInnerFromJSON)),
        'release': !exists(json, 'release') ? undefined : LookupRecordingResponseExistingReleaseFromJSON(json['release']),
    };
}

export function LookupRecordingResponseExistingToJSON(value?: LookupRecordingResponseExisting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording': LookupRecordingResponseExistingRecordingToJSON(value.recording),
        'artists': ((value.artists as Array<any>).map(LookupRecordingResponseExistingArtistsInnerToJSON)),
        'release': LookupRecordingResponseExistingReleaseToJSON(value.release),
    };
}

